export default "__VITE_ASSET__lm0Pcrdl__"